// extracted by mini-css-extract-plugin
module.exports = {"psContainer":"PaymentSuccess_psContainer__1w89X","imageWrapper":"PaymentSuccess_imageWrapper__8t8m2"};